/**
 * Функция для фиксации панели с логотипом при прокрутке страницы.
 * @param {HTMLElement} articlePage - Элемент, относительно которого будет фиксироваться панель.
 */
function fixPanelWithLogo(articlePage) {
  const parentContainer = articlePage;
  const fixedPanel = document.querySelector(".article-page-panel");
  const button = document.getElementById("softdownload");
  const gdzArticleElement = articlePage.querySelector(".gdz-article");

  /**
   * Обновляет позицию и видимость фиксированной панели.
   */
  function updateFixedPanel() {
    const rect = button?.getBoundingClientRect();
    const gdzRect = gdzArticleElement.getBoundingClientRect();
    const parent = parentContainer?.getBoundingClientRect();
    const visibleParent = parent.bottom <= 170;
    if (fixedPanel) {
      if (gdzRect) {
        fixedPanel.style.width = `${gdzRect.width}px`;
      } else {
        fixedPanel.style.width = `${parent.width}px`;
      }

      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

      if (!isVisible && !visibleParent) {
        fixedPanel.classList.add("visible");
      } else {
        fixedPanel.classList.remove("visible");
      }
    }
  }

  // Добавляем обработчики событий для прокрутки и изменения размера окна
  window.addEventListener("scroll", updateFixedPanel);
  window.addEventListener("resize", updateFixedPanel);
}

export default fixPanelWithLogo;
